import { Mail, MessageCircle } from "lucide-react";
import { Reveal, WHATSAPP_URL } from "../landing/shared";

export const DirectContact = () => (
    <section
        id="direct-contact"
        data-testid="direct-contact-section"
        className="bg-night py-24 text-ivory lg:py-28"
    >
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
            <div className="grid gap-10 lg:grid-cols-12 lg:items-center">
                <Reveal className="lg:col-span-6">
                    <p className="flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.3em] text-ivory/60">
                        <span className="h-px w-8 bg-champagne" aria-hidden="true" />
                        Direct Contact
                    </p>
                    <h2 className="mt-5 font-serif text-3xl font-medium tracking-tight sm:text-4xl">
                        Prefer to speak with us directly?
                    </h2>
                    <div className="mt-8 space-y-3 text-sm text-ivory/70">
                        <a
                            href="mailto:contact@afrinexaglobal.org"
                            data-testid="direct-email-contact-link"
                            className="block transition-colors hover:text-champagne"
                        >
                            contact@afrinexaglobal.org
                        </a>
                        <a
                            href="mailto:info@afrinexaglobal.org"
                            data-testid="direct-email-info-link"
                            className="block transition-colors hover:text-champagne"
                        >
                            info@afrinexaglobal.org
                        </a>
                    </div>
                </Reveal>
                <Reveal delay={0.1} className="lg:col-span-6 lg:text-right">
                    <div className="flex flex-col gap-4 sm:flex-row lg:justify-end">
                        <a
                            href={WHATSAPP_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            data-testid="direct-whatsapp-btn"
                            className="inline-flex items-center justify-center gap-2 whitespace-nowrap bg-ivory px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-ink transition-colors duration-300 hover:bg-champagne"
                        >
                            <MessageCircle size={16} strokeWidth={1.5} />
                            WhatsApp +234 814 063 5506
                        </a>
                        <a
                            href="mailto:contact@afrinexaglobal.org"
                            data-testid="direct-contact-cta"
                            className="inline-flex items-center justify-center gap-2 whitespace-nowrap border border-ivory/30 px-8 py-4 text-sm font-semibold uppercase tracking-[0.1em] text-ivory transition-colors duration-300 hover:border-champagne hover:text-champagne"
                        >
                            <Mail size={16} strokeWidth={1.5} />
                            Contact Afrinexa Global
                        </a>
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
